import script from "./ElementTypeAllowParentControl.vue?vue&type=script&setup=true&lang=js"
export * from "./ElementTypeAllowParentControl.vue?vue&type=script&setup=true&lang=js"

import "./ElementTypeAllowParentControl.vue?vue&type=style&index=0&id=1bcf239b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bcf239b"]])

export default __exports__